'use client';

type BoyTripsLogoProps = { compact?: boolean; className?: string }

export function BoyTripsLogo({ compact = false, className = '', }: BoyTripsLogoProps) {
  return (
    <div className={`inline-flex items-center text-text-primary ${compact ? 'gap-2.5' : 'gap-4 sm:gap-5'} ${className}`} aria-label="Boy Trips">
      <svg viewBox="0 0 96 96" className={compact ? 'size-10 shrink-0' : 'size-20 shrink-0 sm:size-24'} role="img" aria-hidden="true">
        <rect x="6" y="6" width="84" height="84" rx="24" fill="var(--color-brand-primary-soft)" stroke="var(--color-border-brand)" strokeWidth="1.5" />
        <circle cx="48" cy="48" r="31" fill="none" stroke="var(--color-brand-secondary)" strokeOpacity="0.28" strokeWidth="1.5" />
        <path d="M18 69C29 45 46 28 78 21" fill="none" stroke="var(--color-brand-primary)" strokeWidth="3" strokeLinecap="round" />
        <circle cx="18" cy="69" r="4" fill="var(--color-brand-primary)" />
        <circle cx="78" cy="21" r="4" fill="var(--color-brand-accent)" />
        <g fill="none" stroke="var(--color-text-primary)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4.4">
          <path d="M28 29v38" />
          <path d="M28 29h12c6.6 0 10.5 3.3 10.5 8.6 0 5.4-4 8.8-10.5 8.8H28" />
          <path d="M28 46.4h13.5c7 0 11.2 3.8 11.2 9.8 0 6.5-4.3 10.8-11.8 10.8H28" />
          <path d="M56 29h17" />
          <path d="M64.5 29v38" />
        </g>
      </svg>

      <div className="flex flex-col leading-none">
        <span className={`font-black text-brand-gradient ${compact ? 'text-xl tracking-[-0.055em]' : 'text-5xl tracking-[-0.075em] sm:text-7xl'}`}>Boy Trips</span>
        {!compact && <span className="mt-2 text-[10px] font-bold uppercase tracking-[0.38em] text-text-muted sm:text-xs">Make the trip happen</span>}
      </div>
    </div>
  );
}
